/**
 * Блок «Типи сайтів»: розкриття прихованих карток.
 *
 * Картки понад ліміт стоять у розмітці з класом .is-extra — сховані стилями,
 * а не вирізані з HTML: підвантаження по кліку зробило б їх невидимими для
 * пошуку, який не натискає кнопок.
 *
 * Висоту сітки анімуємо вручну: grid із auto-висотою сам по собі не
 * переходить плавно, тому міряємо стан до і після, і ведемо height між ними.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.phpdev-types').forEach(function (sec) {
    var grid = sec.querySelector('.tgrid');
    var btn  = sec.querySelector('.tgrid-more');
    if (!grid || !btn) return;

    // Перший вузол кнопки — її підпис; далі йде лічильник у span, який
    // чіпати не можна, тому текст міняємо саме у вузлі, а не через textContent.
    var label = btn.firstChild;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var from = grid.getBoundingClientRect().height;

      grid.classList.toggle('is-open', !open);
      grid.classList.toggle('has-extra', open);
      btn.setAttribute('aria-expanded', String(!open));
      if (label && label.nodeType === 3) {
        label.textContent = (!open ? btn.dataset.collapse : btn.dataset.expand) + ' ';
      }

      if (reduce) return;

      var to = grid.getBoundingClientRect().height;
      grid.style.overflow = 'hidden';
      grid.style.height = from + 'px';
      grid.getBoundingClientRect();            // форсуємо reflow, інакше браузер склеїть обидва значення
      grid.style.transition = 'height .45s cubic-bezier(.22,.61,.36,1)';
      grid.style.height = to + 'px';

      var done = function (e) {
        if (e && e.propertyName !== 'height') return;
        grid.style.height = '';
        grid.style.transition = '';
        grid.style.overflow = '';
        grid.removeEventListener('transitionend', done);
      };
      grid.addEventListener('transitionend', done);
      // Підстраховка: якщо transitionend не прийде (вкладка у фоні), стилі
      // інакше залишаться назавжди і сітка застрягне фіксованої висоти.
      setTimeout(done, 700);
    });
  });
})();
